





































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
       columnasd:[
             {
                tag:'id',
                data:'id',
                active:false
            },
             
           
             {
                tag:'visible',
                data:'visible',
                active:false
            },
             {
                tag:'clave',
                data:'clave',
                active:true
            },
            {
                tag:'departamento',
                data:'departamento',
                active:true
            },
            {
                tag:'nombre_enlace',
                data:'nombre_enlace',
                active:true
            },
             {
                tag:'color',
                data:'color',
                active:true
            },  {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
       ],
  
        id:null as any,

      nombre_enlace:'' as any,
      departamento:null as any,
     clave:null  as any,
         color:0,
              departamentos:[] as any,
         visible:0 as any,
    }
  },
     mixins: [departamentos],
     validations: {
    
           nombre_enlace: {
      required,
    },
      clave: {
      required,
    },
     departamento: {
      required,
    },

      visible: {
      required,
    },
         
     

   
  },
  methods:{
      onChangeVisible(event){

      },   
      async eliminar(row){
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_GENERAL_DEPARTAMENTOS(row).then(response => {

                    if (response != null) {

 this.departamentos=this.departamentos.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar Departamento, refresque la página");

                    }
 this.$root.$emit('loading', false);
                });
      },
     
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 this.color=0;
           
                 this.nombre_enlace=null;

            this.clave=null;
             this.departamento=null;
           this.visible=0;
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_departamentos').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.nombre_enlace=row.nombre_enlace;
this.color=row.color;
            this.clave=row.clave;
             this.departamento=row.departamento;
              this.visible=row.visible;
 $('#ac_modal_departamentos').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_GENERAL_DEPARTAMENTOS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.departamentos.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Departamento, refresque la página");

                    }
                        $("#ac_modal_departamentos").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_GENERAL_DEPARTAMENTOS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Departamento modificado correctamente.");
  this.departamentos=this.departamentos.filter(item => item.id !== dat.id);
 this.departamentos.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Departamento, refresque la página");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)
if(this.color != 0){
let dat={
  id:this.id,
     
           visible:this.visible,
           nombre_enlace:this.nombre_enlace,
color:this.color,
            departamento:this.departamento,
             clave:this.clave,
             idsecretaria:this.$store.state.secretaria_sel.id,
            idmunicipio:this.$store.state.user.usuario.id_municipio

            
    
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

}else{
let dat={
  id:this.id,
     
           visible:this.visible,
           nombre_enlace:this.nombre_enlace,
color:this.$store.state.secretaria_sel.color,
            departamento:this.departamento,
             clave:this.clave,
             idsecretaria:this.$store.state.secretaria_sel.id,
            idmunicipio:this.$store.state.user.usuario.id_municipio
    
}
 console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }
   
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
iddependencia:this.$store.state.secretaria_sel.id,

idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

